var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7069 4.29303C12.5194 4.10556 12.2651 4.00024 11.9999 4.00024C11.7348 4.00024 11.4804 4.10556 11.2929 4.29303L4.29292 11.293C4.11076 11.4816 4.00997 11.7342 4.01224 11.9964C4.01452 12.2586 4.11969 12.5094 4.3051 12.6948C4.49051 12.8803 4.74132 12.9854 5.00352 12.9877C5.26571 12.99 5.51832 12.8892 5.70692 12.707L5.99992 12.414V19C5.99992 19.2652 6.10528 19.5196 6.29281 19.7071C6.48035 19.8947 6.7347 20 6.99992 20H8.99992C9.26514 20 9.51949 19.8947 9.70703 19.7071C9.89456 19.5196 9.99992 19.2652 9.99992 19V17C9.99992 16.7348 10.1053 16.4805 10.2928 16.2929C10.4803 16.1054 10.7347 16 10.9999 16H12.9999C13.2651 16 13.5195 16.1054 13.707 16.2929C13.8946 16.4805 13.9999 16.7348 13.9999 17V19C13.9999 19.2652 14.1053 19.5196 14.2928 19.7071C14.4803 19.8947 14.7347 20 14.9999 20H16.9999C17.2651 20 17.5195 19.8947 17.707 19.7071C17.8946 19.5196 17.9999 19.2652 17.9999 19V12.414L18.2929 12.707C18.4815 12.8892 18.7341 12.99 18.9963 12.9877C19.2585 12.9854 19.5093 12.8803 19.6947 12.6948C19.8801 12.5094 19.9853 12.2586 19.9876 11.9964C19.9899 11.7342 19.8891 11.4816 19.7069 11.293L12.7069 4.29303Z",
    fill: "#B0BABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDisabled);
export default __webpack_public_path__ + "static/media/HomeDisabled.a1383d45e058d14ea6d7dfc01499062d.svg";
export { ForwardRef as ReactComponent };